import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";

import "./style.scss";

const DefaultInputTextUi = ({
    id = "",
    value = "",
    label = "",
    onChange = () => {},
    className = "",
    leftIcon = "",
    rightText = "",
    rightIcon = "",
    disabled = false,
    error = "",
    type = "text",
    placeholder = "",
    classNameInput = "",
    keyfilter = "",
    ref,
    suggestEmailValue,
    handleClickSuggest,
    onClick,
    autoComplete = "off",
    noAb,
}) => {
    const regex = new RegExp(`^@${(value.match(/@(.*)/)?.[1] || "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}`, "i");
    const newSuggestEmail = !value.includes("@") ? suggestEmail : suggestEmail.filter((i) => regex.test(i.sug));

    return (
        <div className={`input-text-ui ${leftIcon ? "input-text-ui_left-icon" : ""} ${rightIcon ? "input-text-ui_right-icon" : ""} ${rightText ? "input-text-ui_right-text" : ""} ${className} ${noAb ? "" : "ab_test"}`}>
            <div className="p-inputgroup flex-1">
                <FloatLabel>
                    <InputText
                        id={id}
                        ref={ref}
                        label={label}
                        value={value}
                        onChange={onChange}
                        className={`input-text-inp-ui ${classNameInput} ${value.length ? "filled" : ""}`}
                        disabled={disabled}
                        type={type}
                        keyfilter={keyfilter}
                        invalid={!!error}
                        onClick={onClick}
                        autoComplete={autoComplete}
                    />
                    <label htmlFor={id} className={`input-text-ui__float ${value.length ? "filled" : ""}`}>
                        {placeholder}
                    </label>
                </FloatLabel>

                {suggestEmailValue && newSuggestEmail.length > 0 && (
                    <div className="input__email_suggest">
                        {newSuggestEmail.map((it, idx) => (
                            <span className="suggest__item" key={idx} onClick={() => handleClickSuggest(it.sug, value)}>
                                {value.split("@")[0]}
                                {it.sug}
                            </span>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

const suggestEmail = [
    { sug: "@yandex.ru" },
    { sug: "@mail.ru" },
    { sug: "@gmail.com" },
    { sug: "@bk.ru" },
    { sug: "@inbox.ru" },
    { sug: "@list.ru" },
    { sug: "@rambler.ru" },
    { sug: "@yahoo.com" },
    { sug: "@outlook.com" },
    { sug: "@icloud.com" },
    { sug: "@ya.ru" },
    { sug: "@proton.me" },
    { sug: "@live.ru" },
    { sug: "@msn.com" },
    { sug: "@meta.ua" },
];

export default DefaultInputTextUi;
